(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7312],{

/***/ 37973:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[productSlug]",
      function () {
        return __webpack_require__(69447);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24100:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/defaultpic.119a8e64.webp","height":269,"width":264,"blurDataURL":"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoIAAgAAkA4JaQAA3AA/vgQAAA=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 69447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96220);
/* harmony import */ var _components_MetaWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28496);
/* harmony import */ var _images_defaultpic_webp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24100);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _services_actionsArray__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84189);









var ShopPageProduct = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4012), __webpack_require__.e(4792), __webpack_require__.e(2951), __webpack_require__.e(6258), __webpack_require__.e(8849)]).then(__webpack_require__.bind(__webpack_require__, 68849));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68849)
            ];
        }
    }
});
var ProductInnerPage = function(props) {
    var ref;
    var relatedProducts = props.relatedProducts, serverSideProduct = props.serverSideProduct, locale = props.locale, productSlug = props.productSlug, rate = props.rate, dispatches = props.dispatches, currencies = props.currencies, configurableVariantes = props.configurableVariantes, bundle = props.bundle, metas = props.metas, getBuilderData = props.getBuilderData, translations = props.translations, dbName = props.dbName, domain = props.domain;
    var ref1 = serverSideProduct || {}, _product_flat = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(ref1.product_flat, 1), tmp = _product_flat[0], ref2 = tmp === void 0 ? {} : tmp, _meta_title = ref2.meta_title, meta_title = _meta_title === void 0 ? "" : _meta_title, _meta_keywords = ref2.meta_keywords, meta_keywords = _meta_keywords === void 0 ? "" : _meta_keywords, _meta_description = ref2.meta_description, meta_description = _meta_description === void 0 ? "" : _meta_description, _name = ref2.name, name = _name === void 0 ? "" : _name, _url_key = ref2.url_key, url_key = _url_key === void 0 ? "" : _url_key, _short_description = ref2.short_description, short_description = _short_description === void 0 ? "" : _short_description, _yoast_products = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(ref1.yoast_products, 1), tmp1 = _yoast_products[0], ref3 = tmp1 === void 0 ? {} : tmp1, _yoast_facebook_description = ref3.yoast_facebook_description, yoast_facebook_description = _yoast_facebook_description === void 0 ? "" : _yoast_facebook_description, _yoast_facebook_title = ref3.yoast_facebook_title, yoast_facebook_title = _yoast_facebook_title === void 0 ? "" : _yoast_facebook_title, _yoast_twitter_description = ref3.yoast_twitter_description, yoast_twitter_description = _yoast_twitter_description === void 0 ? "" : _yoast_twitter_description, _yoast_twitter_title = ref3.yoast_twitter_title, yoast_twitter_title = _yoast_twitter_title === void 0 ? "" : _yoast_twitter_title, _yoast_focus_keyword = ref3.yoast_focus_keyword, yoast_focus_keyword = _yoast_focus_keyword === void 0 ? "" : _yoast_focus_keyword, _product_images = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(ref1.product_images, 1), tmp2 = _product_images[0], ref4 = tmp2 === void 0 ? {} : tmp2, _path = ref4.path, path = _path === void 0 ? "" : _path, productId = ref1.id, productType = ref1.type;
    var checkRelatedProducts = relatedProducts === null || relatedProducts === void 0 ? void 0 : relatedProducts.filter(function(item) {
        var ref;
        return ((ref = item.product_flat[0]) === null || ref === void 0 ? void 0 : ref.product_id) !== productId;
    });
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(serverSideProduct), product = ref5[0], setProduct = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), changes = ref6[0], setChanges = ref6[1];
    var dispatch = _store__WEBPACK_IMPORTED_MODULE_3__/* ["default"].dispatch */ .Z.dispatch;
    var imgObj = {
        large_image_url: _images_defaultpic_webp__WEBPACK_IMPORTED_MODULE_5__/* ["default"].src */ .Z.src,
        medium_image_url: _images_defaultpic_webp__WEBPACK_IMPORTED_MODULE_5__/* ["default"].src */ .Z.src,
        original_image_url: _images_defaultpic_webp__WEBPACK_IMPORTED_MODULE_5__/* ["default"].src */ .Z.src,
        path: _images_defaultpic_webp__WEBPACK_IMPORTED_MODULE_5__/* ["default"].src */ .Z.src,
        small_image_url: _images_defaultpic_webp__WEBPACK_IMPORTED_MODULE_5__/* ["default"].src */ .Z.src,
        url: _images_defaultpic_webp__WEBPACK_IMPORTED_MODULE_5__/* ["default"].src */ .Z.src
    };
    if (productType !== "bundle" && ((ref = product.product_images) === null || ref === void 0 ? void 0 : ref.length) == 0) {
        product.product_images.push(imgObj);
    }
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        window.history.replaceState(null, "", window.location.pathname);
        setProduct(serverSideProduct);
        setChanges(!changes);
        router.push(window.location.pathname);
    }, [
        productSlug,
        locale,
        rate
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        for(var actionKey in dispatches){
            // @ts-ignore
            dispatch(_services_actionsArray__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z[actionKey](dispatches[actionKey]));
        }
    }, [
        locale,
        currencies
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MetaWrapper__WEBPACK_IMPORTED_MODULE_4__/* .MetaWrapper */ .Q, {
        dbName: dbName,
        domain: domain,
        locale: locale,
        title: !!meta_title ? meta_title : name,
        m_title: meta_title,
        m_desc: !!meta_description ? meta_description : short_description,
        m_key: meta_keywords,
        m_img: dbName && path,
        m_url: dbName && "https://".concat(dbName, "/").concat(locale, "/").concat(url_key),
        FB_desc: yoast_facebook_description,
        FB_title: yoast_facebook_title,
        TW_desc: yoast_twitter_description,
        TW_title: yoast_twitter_title,
        y_keyword: yoast_focus_keyword,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ShopPageProduct, {
            rate: rate,
            layout: "standard",
            productSlug: productSlug,
            relProduct: checkRelatedProducts,
            productData: product,
            configurableVariantes: configurableVariantes,
            locale: locale,
            loading: true,
            changes: changes,
            bundle: bundle,
            dbName: dbName,
            currencies: currencies,
            sidebarPosition: "undefined",
            domain: "",
            getBuilderData: getBuilderData,
            translations: translations
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ProductInnerPage);


/***/ }),

/***/ 84189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _store_general__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26298);
/* harmony import */ var _store_token__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46607);
/* harmony import */ var _store_currency__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10668);
/* harmony import */ var _store_locale__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98410);
/* harmony import */ var _store_rate__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38691);





/* harmony default export */ __webpack_exports__["Z"] = ({
    setDomain: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setDomain */ .W9,
    setSocial: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setSocial */ .It,
    setFbPixel: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setFbPixel */ .XX,
    setPopup: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setPopup */ .ZA,
    setRate: _store_rate__WEBPACK_IMPORTED_MODULE_4__/* .setRate */ .FY,
    setCustomJs: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setCustomJs */ .ie,
    setBackorders: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setBackorders */ .G_,
    setCacheVersion: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setCacheVersion */ .uN,
    setCoreConfigs: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setCoreConfigs */ .ly,
    setTranslations: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setTranslations */ .Yh,
    AddCartToken: _store_token__WEBPACK_IMPORTED_MODULE_1__/* .AddCartToken */ .y,
    changeCurrency: _store_currency__WEBPACK_IMPORTED_MODULE_2__/* .changeCurrency */ .sy,
    setCurrencies: _store_currency__WEBPACK_IMPORTED_MODULE_2__/* .setCurrencies */ .HC,
    setLocaleList: _store_locale__WEBPACK_IMPORTED_MODULE_3__/* .setLocaleList */ .p4,
    changeLocale: _store_locale__WEBPACK_IMPORTED_MODULE_3__/* .changeLocale */ .wo,
    setMenuList: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setMenuList */ .kT,
    setCategories: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setCategories */ .DG,
    setInitialMinPrice: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setInitialMinPrice */ .E8,
    setInitialMaxPrice: _store_general__WEBPACK_IMPORTED_MODULE_0__/* .setInitialMaxPrice */ .lm
});


/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6764,8366,6002,9774,2888,179], function() { return __webpack_exec__(37973); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);